'use client';

import { lazy, memo, Suspense } from 'react';
import { useAuth } from '@//providers/AuthProvider';
import AuthNavSkeleton from './AuthNavSkeleton';
import UnauthenticatedButtons from './UnauthenticatedButtons';

const AuthenticatedUserNav = lazy(() => import('./AuthenticatedUserNav'));

const AuthSection = () => {
  const { initialized } = useAuth();

  if (!initialized) {
    return <UnauthenticatedButtons />;
  }

  return (
    <Suspense fallback={<AuthNavSkeleton />}>
      <AuthenticatedUserNav />
    </Suspense>
  );
};

export default memo(AuthSection);
